import React from 'react';
import { Trans } from 'lingui-react';
import { compose, setDisplayName } from 'recompose';

import { Text } from 'base-components';
import { px2rem } from 'decisiv-ui-utils';
import { Container } from 'styled-components-reactive-grid';

import useContext from 'utils/useContext';
import { reportTypes } from 'pages/Reports/constants';

import ReportConfigBuilder from './ReportConfigBuilder';
import InputFieldWithSuggestions from './ReportConfigBuilder/InputFieldWithSuggestions';
import ReportConfigBuilderContext from './ReportConfigBuilder/Context';
import { configTypes } from './ReportConfigBuilder/constants';

const CustomFilters = () => (
  <Container modifiers="padScale_0" style={{ marginTop: px2rem(20) }}>
    <Text>
      <Trans>Advanced Filters (Optional)</Trans>
    </Text>
    <InputFieldWithSuggestions
      configType={configTypes.inboundProgramName}
      grouped
    />
    <InputFieldWithSuggestions configType={configTypes.dealerName} grouped />
  </Container>
);

const CaseBillingReportCustomFilters = compose(
  setDisplayName('CaseBillingReportCustomFilters'),
  useContext(ReportConfigBuilderContext),
)(CustomFilters);

const CaseBillingReport = () => (
  <ReportConfigBuilder reportType={reportTypes.caseBillingReport}>
    <ReportConfigBuilder.Header />
    <CaseBillingReportCustomFilters />
    <ReportConfigBuilder.Footer />
  </ReportConfigBuilder>
);

export default CaseBillingReport;



// WEBPACK FOOTER //
// ./src/compositions/Reports/CaseBillingReport.js